export function handleAccountCardKeyDown(
  event: { key: string; preventDefault(): void },
  loading: boolean,
  activate: () => void,
) {
  const isSpace = event.key === " " || event.key === "Spacebar";
  if (isSpace) event.preventDefault();
  if (loading || (event.key !== "Enter" && !isSpace)) return false;
  activate();
  return true;
}

export async function runExclusiveAccountAction(
  inFlight: { current: boolean },
  action: () => Promise<void>,
) {
  if (inFlight.current) return false;
  inFlight.current = true;
  try {
    await action();
    return true;
  } finally {
    inFlight.current = false;
  }
}

export function canOfferOtherAccountAction(
  trustedClient: { clientId: string; clientName: string } | undefined,
) {
  return trustedClient !== undefined;
}
